export function track(eventName: string, eventProperties?: Record<string, unknown>) {
  analytics?.track(eventName, eventProperties, {
    integrations: {
      "Facebook Pixel": false,
      "Facebook Conversions API": false,
      "Facebook Offline Conversions": false,
    },
  });
}
